import { render, staticRenderFns } from "./asset_management.vue?vue&type=template&id=9ff518e8&scoped=true"
import script from "./asset_management.vue?vue&type=script&lang=js"
export * from "./asset_management.vue?vue&type=script&lang=js"
import style0 from "./asset_management.vue?vue&type=style&index=0&id=9ff518e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff518e8",
  null
  
)

export default component.exports